//MIDDLEWARES
import auth from "./../router/middleware/auth";
import guest from "./../router/middleware/guest";
import rolesAndPermissions from "./../router/middleware/rolesAndPermissions";

//USERS
import UsersCreate from "./../views/users/Create";
import UsersShow from "./../views/users/Show";

//LAYOUTS
import LayoutsCreate from "./../views/layouts/Create";

//LAYOUTS
import ProductsCreate from "./../views/products/Create";

const baseMiddleware = [auth, rolesAndPermissions];

export default [
  {
    path: "/internal/tabloid-print/:token",
    name: "tabloid-print",
    component: () => import("../views/tabloids/TabloidPrint"),
    meta: {
      title: "ImpressÃ£o de Tabloid",
      middleware: [auth],
    },
  },
  {
    path: "/",
    name: "app",
    redirect: { name: "dashboard" },
    component: () => import("../components/layout/Main"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("../views/Dashboard"),
        meta: {
          title: "Dashboard",
          middleware: baseMiddleware,
        },
      },
      {
        path: "/campaign",
        name: "campaign",
        component: () => import("../views/posters/Campaign"),
        meta: {
          title: "Campanha",
          middleware: baseMiddleware,
          permissions: ["cartaz automatizado"],
        },
      },
      {
        path: "/wholesale",
        name: "wholesale",
        component: () => import("../views/posters/Wholesale"),
        meta: {
          title: "Atacado",
          middleware: baseMiddleware,
          permissions: ["cartaz atacado"],
        },
      },
      {
        path: "/offer",
        name: "offer",
        component: () => import("../views/posters/Offer"),
        meta: {
          title: "Oferta",
          middleware: baseMiddleware,
          permissions: ["cartaz manual"],
        },
      },
      {
        path: "/cart",
        name: "cart",
        component: () => import("../views/posters/Cart"),
        meta: {
          title: "Carrinho",
          middleware: baseMiddleware,
          permissions: ["cartaz carrinho"],
        },
      },
      {
        path: "/portrait-poster",
        name: "portrait-poster",
        component: () => import("../views/posters/PortraitPoster"),
        meta: {
          title: "Gerar cartaz - retrato",
          middleware: baseMiddleware,
        },
      },
      {
        path: "/landscape-poster",
        name: "landscape-poster",
        component: () => import("../views/posters/LandscapePoster"),
        meta: {
          title: "Gerar cartaz - paisagem",
          middleware: baseMiddleware,
        },
      },
      {
        path: "/mega-poster",
        name: "mega-poster",
        component: () => import("../views/posters/MegaPoster"),
        meta: {
          title: "Gerar cartaz - mega",
          middleware: baseMiddleware,
        },
      },
      {
        path: "/mega-poster-manual",
        name: "mega-poster-manual",
        component: () => import("../views/posters/MegaPosterManual"),
        meta: {
          title: "Gerar cartaz - mega",
          middleware: baseMiddleware,
        },
      },
      {
        path: "/cart-poster",
        name: "cart-poster",
        component: () => import("../views/posters/CartPoster"),
        meta: {
          title: "Gerar cartaz - carrinho",
          middleware: baseMiddleware,
        },
      },
      {
        path: "/wholesale-poster",
        name: "wholesale-poster",
        component: () => import("../views/posters/WholesalePoster"),
        meta: {
          title: "Gerar cartaz - atacado",
          middleware: baseMiddleware,
        },
      },
      {
        path: "/users",
        name: "users.index",
        component: () => import("../views/users/Index"),
        meta: {
          title: "Usuários",
          middleware: baseMiddleware,
          roles: ["super-admin"],
        },
      },
      {
        path: "/users/create/:id?",
        name: "users.create",
        component: UsersCreate,
        meta: {
          title: "Adicionar Usuário",
          middleware: baseMiddleware,
          roles: ["super-admin"],
        },
      },
      {
        path: "/users/show/:id",
        name: "users.show",
        component: UsersShow,
        meta: {
          title: "Editar Usuário",
          middleware: baseMiddleware,
          roles: ["super-admin"],
        },
      },
      {
        path: "/layouts",
        name: "layouts.index",
        component: () => import("../views/layouts/Index"),
        meta: {
          title: "Layouts",
          middleware: baseMiddleware,
          permissions: ["layouts"],
        },
      },
      {
        path: "/layouts/create/:id?",
        name: "layouts.create",
        component: LayoutsCreate,
        meta: {
          title: "Adicionar Layout",
          middleware: baseMiddleware,
          permissions: ["layouts"],
        },
      },
      {
        path: "/tabloid",
        name: "tabloid",
        component: () => import("../views/tabloids/TabloidSteps"),
        meta: {
          title: "Tabloides",
          middleware: baseMiddleware,
          permissions: ["gerar tabloide"],
        },
      },
      {
        path: "/tabloid-generate",
        name: "tabloid-generate",
        component: () => import("../views/tabloids/TabloidGenerate"),
        meta: {
          title: "Gerar Tabloide",
          middleware: baseMiddleware,
        },
        children: [
          {
            path: "layouts",
            name: "tabloid-generate.layouts",
            component: {},
            meta: {
              layoutsModalShowing: true,
            },
          },
          {
            path: "products",
            name: "tabloid-generate.products",
            component: {},
            meta: {
              productsModalShowing: true,
            },
          },
          {
            path: "dates",
            name: "tabloid-generate.dates",
            component: {},
            meta: {
              datesModalShowing: true,
            },
          },
          {
            path: "footers",
            name: "tabloid-generate.footers",
            component: {},
            meta: {
              footerModalShowing: true,
            },
          },
          {
            path: "logo",
            name: "tabloid-generate.logo",
            component: {},
            meta: {
              logoModalShowing: true,
            },
          },
        ],
      },
      {
        path: "/products",
        name: "products.index",
        component: () => import("../views/products/Index"),
        meta: {
          title: "Meus Produtos",
          middleware: baseMiddleware,
          permissions: ["meus produtos"],
        },
      },
      {
        path: "/products/create/:id?",
        name: "products.create",
        component: ProductsCreate,
        meta: {
          title: "Adicionar Produto",
          middleware: baseMiddleware,
          permissions: ["meus produtos"],
        },
      },
      {
        path: "/configurations",
        name: "configurations.index",
        component: () => import("../views/configurations/Index"),
        meta: {
          title: "Configurações",
          middleware: baseMiddleware,
        },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/auth/Login"),
    meta: {
      title: "Login",
      middleware: [guest],
    },
  },
];
